import React from 'react';
import * as R from 'ramda';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import DoneAll from '@mui/icons-material/DoneAll';

const NoAssociatedCard = ({ type }) => {
  return (
    <Box
      bgcolor="graphic.lighter"
      borderRadius="4px"
      fontFamily="Gothic A1"
      // eslint-disable-next-line sort-keys-fix/sort-keys-fix
      padding={3}
      textAlign="center"
      width="100%"
    >
      <DoneAll
        sx={{
          color: 'text.secondary',
          height: 38,
          mb: 1,
          width: 38,
        }}
      />
      <Typography fontWeight={300} sx={{ color: 'text.secondary' }} variant="body1">
        You have no {type}s associated with this
        {R.equals(type, 'shipment') ? ' batch' : ' shipment'}
      </Typography>
    </Box>
  );
};

NoAssociatedCard.propTypes = {
  type: PropTypes.string.isRequired,
};

export default NoAssociatedCard;
